import { useLocalStorage } from "usehooks-ts";

import { useCallManager } from "../../hooks/useCallManager";
import { useIsDesktop } from "../../hooks/useIsDesktop";
import { DownloadAppOrContinueOnWeb } from "../Onboarding/DownloadAppOrContinueOnWeb";
import { CallManagerUI } from "./CallManagerUI";
import { CallManagerWrapper } from "./CallManagerWrapper";

export function CallManager() {
  const [hasChosenToContinueOnWeb, setHasChosenToContinueOnWeb] =
    useLocalStorage("continue-on-web", false);
  const callManagerProps = useCallManager();
  const isDesktop = useIsDesktop();

  const shouldAskToContinueOnWeb = !isDesktop && !hasChosenToContinueOnWeb;

  return (
    <CallManagerWrapper>
      {shouldAskToContinueOnWeb ? (
        <DownloadAppOrContinueOnWeb
          continueOnWeb={() => setHasChosenToContinueOnWeb(true)}
        />
      ) : (
        <CallManagerUI {...callManagerProps} />
      )}
    </CallManagerWrapper>
  );
}
